import React from 'react';
import RubricView from './RubricView';
import { register } from '../../../i18n';

const t = register('PanelMenu');

const RubricPanel = ({ lessonElementId }) => {
  return (
    <div className='rubric-panel flyout-panel' id={`${lessonElementId}-rubric-panel`}>
      <h2 className='panel-header'>{t('rubricPanel')}</h2>
      <RubricView lessonElementId={lessonElementId} />
    </div>
  );
};

export default RubricPanel;
